module.exports = __webpack_public_path__ + "media/images/no_content.icon.response-05457b4f.png";